import { AuthorWithAiApiError } from './authorWithAiApi';

/**
 * The server's reason for refusing a build started from a library item (a
 * Centerstage video or a Question Bank question): the per-item message when
 * it gave one, else its message for a 422 or 503, else the caller's fallback.
 */
export function buildErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof AuthorWithAiApiError && (error.status === 422 || error.status === 503)) {
    return error.fields[0]?.message ?? error.message;
  }
  return fallback;
}
